import * as fromDatatype from '../datatype-library/index';

export interface bl_applet_store_hostname_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  applet_store_guid: fromDatatype.GuidDataFieldInterface;
  hostname_guid: fromDatatype.GuidDataFieldInterface;
  hostname_url: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_updated: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_applet_store_hostname_link_RowClass
  implements bl_applet_store_hostname_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  applet_store_guid: fromDatatype.GuidDataFieldInterface;
  hostname_guid: fromDatatype.GuidDataFieldInterface;
  hostname_url: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_updated: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
